import { useState, useEffect } from "react";
import axios from "axios";
import Breadcrumb from "../../components/breadcrumb/index";
import Update_data_modal from "../../components/manageInvoice/update_data_modal/index";
import DataTable_Component from "../../components/jobs/Data Table/index";
import Status_modal from "../../components/manageInvoice/status_modal/index";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEye,
  faPenToSquare,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";

import Layouts from "../../layouts/layouts";
import Add_data_modal from "../../components/jobs/update_data_modal";
import JobDetailModal from "../../components/jobs/Job Details";
import * as XLSX from "xlsx";

export default function Job() {
  const title = "Job Details";
  const [apistate, setApiState] = useState([]);
  const [apicol, setApiCol] = useState([]);
  const [selectVal, setSelectval] = useState([]);
  const [openModal, setOpenModal] = useState(true);

  const [open_add_modal, setOpen_add_modal] = useState({
    render: true,
    modal_open: false,
  });

  const [open_update_modal, setOpen_update_modal] = useState({
    render: true,
    modal_open: false,
  });
  const [update_modal_data, setUpdate_modal_data] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [showJobDetailModal, setShowJobDetailModal] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null);

  const brad = [
    {
      name: "Home",
    },
    {
      name: title,
    },
  ];
  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "2-digit", day: "2-digit" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };
  const columns = [
    {
      name: <b>Job Id</b>,
      selector: (row) => row.jobId,
      sortable: true,
    },
    {
      name: <b>Title</b>,
      selector: (row) => row.title,
      sortable: true,
    },
    {
      name: <b>Openings</b>,
      selector: (row) => row.openings,
      sortable: true,
    },
    {
      name: <b>Date</b>,
      selector: (row) => formatDate(row.date || "-"),
      sortable: true,
    },

    {
      name: <b>City</b>,
      selector: (row) => row.city,
      sortable: true,
    },

    {
      name: <b>Created By</b>,
      selector: (row) => (row.createdBy ? row.createdBy.user_email : "-"),
      sortable: true,
    },

    {
      name: <b>Status</b>,
      cell: (row) => {
        const status = row.status?.toLowerCase();
        return (
          <button
            className={`btn px-2 py-1 ${
              // Adjusted padding for space
              status === "In-Progress"
                ? "btn-success"
                : status === "Open"
                  ? "btn-danger"
                  : status === "Close"
                    ? "btn-danger"
                    : ""
            }`}
            style={{
              minWidth: "70px", // Increased minimum width to fit longer text
              fontSize: "14px", // Adjust font size if needed
              whiteSpace: "nowrap", // Prevents text from wrapping to new lines
            }}
          >
            {row.status || "Unknown"}
          </button>
        );
      },
      // Adding width for the column itself to avoid overlap
      width: "150px", // Adjust width as needed
    },

    {
      name: <b>Action</b>,
      cell: (row) => (
        <>
          <button
            onClick={() => setUpdateStoreBtn(row)}
            className="btn btn-info btn-sm ms-1"
          >
            <FontAwesomeIcon icon={faPenToSquare} />
          </button>
          <button
            onClick={() => delete_row(row)}
            className=" btn btn-danger btn-sm ms-1"
          >
            <FontAwesomeIcon icon={faTrash} />
          </button>

          <button
            onClick={() => viewJob(row)}
            className="btn btn-primary btn-sm ms-1"
          >
            <FontAwesomeIcon icon={faEye} />
          </button>
        </>
      ),
    },
  ];

  const exportToExcel = () => {
    const transformedData = apistate.map((job) => ({
      Job_ID: job.jobId,
      "Job Title": job.title,
      Opening: job.openings,
      City: job.city,
      Status: job.status,
      Date: job.date,
      Comments: job.comment,
    }));

    const worksheet = XLSX.utils.json_to_sheet(transformedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Jobs");

    XLSX.writeFile(workbook, "jobs.xlsx");
  };

  const handleShow = (row) => {
    setOpenModal(!openModal);
    setSelectval(row);
  };

  const fetchData = async (page) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        console.error("No token found");
        return;
      }
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/v1/jobs`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (Array.isArray(response.data.jobs)) {
        setApiState(response.data.jobs);
      } else {
        console.error("Unexpected data format from API", response.data);
      }
      setApiCol(columns);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  useEffect(() => {
    fetchData(currentPage);
  }, [currentPage]);

  const setStoreBtn = () => {
    setOpen_add_modal({ render: !open_add_modal.render, modal_open: true });
  };

  const delete_row = (row) => {
    Swal.fire({
      icon: "warning",
      title: "You won't be able to revert this!",
      showCancelButton: true,
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        const token = localStorage.getItem("token");
        if (!token) {
          console.error("No token found");
          return;
        }

        axios
          .delete(
            `${process.env.REACT_APP_BASE_URL}/api/v1/jobs/${row.jobId}`,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            },
          )
          .then(() => {
            Swal.fire("Deleted!", "Job has been deleted.", "success");
            fetchData(currentPage);
          })
          .catch((error) => {
            Swal.fire("Error!", "Job could not be deleted.", "error");
            console.error("Error deleting job:", error);
          });
      }
    });
  };

  const setUpdateStoreBtn = (row) => {
    setOpen_update_modal({
      render: !open_update_modal.render,
      modal_open: true,
    });
    setUpdate_modal_data(row);
  };

  const viewJob = (job) => {
    setSelectedJob(job);
    setShowJobDetailModal(true);
  };
  const updateJob = (updatedJob) => {
    setApiState((prev) =>
      prev.map((job) => (job.jobId === updatedJob.jobId ? updatedJob : job)),
    );
  };

  const handleUpdateJob = (updatedJobData) => {
    const token = localStorage.getItem("token");
    if (!token) {
      console.error("No token found");
      return;
    }

    axios
      .put(
        `${process.env.REACT_APP_BASE_URL}/api/v1/jobs/${updatedJobData.jobId}`,
        updatedJobData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then((response) => {
        Swal.fire("Updated!", "Job details have been updated.", "success");
        updateJob(response.data.job); // update local state
      })
      .catch((error) => {
        Swal.fire("Error!", "Job details could not be updated.", "error");
        console.error(
          "Error updating job:",
          error.response ? error.response.data : error.message,
        );
      });
  };

  return (
    <>
      <Layouts />
      <Status_modal row={selectVal} openModal={openModal} />
      <Add_data_modal
        select_data={update_modal_data}
        open_update_data_modal={open_update_modal}
        onUpdateJob={updateJob}
      />
      <JobDetailModal
        show={showJobDetailModal}
        onHide={() => setShowJobDetailModal(false)}
        job={selectedJob}
      />
      <div className="container-fluid">
        <div className="row my-3">
          <div className="col-12">
            <div className="card" style={{ borderTop: "2px solid #4723d9" }}>
              <div className="card-header d-flex justify-content-between border-bottom pb-1">
                <h4>{title}</h4>
                <div>
                  <Link to="/create-job">
                    <div className="btn btn-info btn-sm text-white me-2">
                      Add Job Type
                    </div>
                  </Link>
                  <button
                    onClick={exportToExcel}
                    className="btn btn-success btn-sm text-white"
                  >
                    Export to Excel
                  </button>
                </div>
              </div>
              <div className="card-body">
                {apistate.length > 0 ? (
                  <DataTable_Component
                    searchBy="title"
                    title_btn={true}
                    title="Job List"
                    apidata={apistate}
                    columns={apicol}
                  />
                ) : (
                  <p>Loading...</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
